type PickingPhase = 'picking' | 'packing'

export interface PickingActivityEvent {
  orderId: number
  phase: PickingPhase
  source?: 'scanner' | 'checkbox' | 'bulk' | 'package-detail'
}

type PickingActivityListener = (event: PickingActivityEvent) => void

const listeners = new Set<PickingActivityListener>()

export function notifyPickingActivity(event: PickingActivityEvent) {
  if (!event?.orderId || !event.phase) return
  listeners.forEach(listener => {
    try {
      listener(event)
    } catch (error) {
      console.error('Picking activity listener failed', error)
    }
  })
}

export function subscribeToPickingActivity(listener: PickingActivityListener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
